'use client';

import useEventCallback from '@mui/utils/useEventCallback';
export default useEventCallback;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/useEventCallback.js
// module id = 234
// module chunks = 25